















import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },

    props: {
        index: {
            type: Number,
            required: true
        },
        bedroomSurface: {
            type: Object,
            required: false,
            default: () => { 
                return {
                    "surface": 0
                };
            }
        }
    },
    data: function() {
        return {
            pathInStore: `property.bedroom.items.${this.index}.surface`,
        };
    },
    methods: {
        updateValue: function(floorAreaBedroom: number): void {
            this.$emit("update-value", floorAreaBedroom, this.index);
        },
        onBlur: function(): void {
            this.$emit("blur");
        }
    }
});

